import { render, staticRenderFns } from "./Anmeldeformular.vue?vue&type=template&id=6ba3eaca&scoped=true&"
import script from "./Anmeldeformular.vue?vue&type=script&lang=js&"
export * from "./Anmeldeformular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba3eaca",
  null
  
)

export default component.exports